import endpoints, { axios } from "../../config/api";

async function getNewFolder(folderId: string) {
  return await (await axios.get(endpoints.newfolders.byId(folderId))).data;
}

export default getNewFolder;
